//-----------------------------------
// fitguide.js
// => theme/sections/fit-guide-nav-new.liquid
// => theme/sections/fit-guide-size-calculator.liquid
// => theme/sections/size-charts.liquid
// => theme/sections/fit-guide-bottom.liquid
//-----------------------------------
import $ from 'jquery';
import Vue from 'vue';

export const fitguide = {
  init(){
    fitguide.initalizeVue()
  },
  initalizeVue(){
    const fitguideVue = new Vue({
      el: '#fitguide',
      delimiters: ['#{', '}'],
      data:{
        bandMeasurement: null,
        bustSize: null,
        braSize: '',
        braletteSize: '',
        bustySize: '',
        calcFailure: false,
        recoCollections: [],
        sisterInput: '',
        sisterRowHighlight: null,
        sisterIndex: null,
        upperSister: '',
        lowerSister: '',
        upperSisterUrl: '',
        notCarried: ['28A','30A','30G','40A','42A','42B', '42C','42D','42G'],
        showEmailCapture: false,
        showEmailCaptureSuccess: false,
        lowerSisterUrl: '',
        sisterFailure: false,
        sisterChart: [
          ['32B', '34A'],
          ['32C', '34B', '36A'],
          ['32D', '34C', '36B'],
          ['32DD', '34D', '36C', '38B'],
          ['32DDD', '34DD', '36D', '38C','40B'],
          ['32G','34DDD', '36DD', '38D', '40C', '42B'],
          ['','34G', '36DDD','38DD', '40D', '42C'],
          ['', '', '36G', '38DDD', '40DD', '42D'],
          ['', '', '', '38G', '40DDD', '42DD'],
          ['', '', '', '', '40G','42DDD']
        ],
        sizeCharts: {
         "BRALETTES": [
           [ 'XS', 'S', 'M', 'L', 'XL', '2XL'],
            [ '30 A/B', '32 A/B', '34 B/C', '36 B/C', '38 B/C', '40 B/C']
          ],
          "PANTIES": [
            ['SIZE', 'XS', 'S', 'M', 'L', 'XL',],
             ['', 'SIZE 4', 'SIZE 5', 'SIZE 6', 'SIZE 7', 'SIZE 8'],
             ['WAIST', '25"-26"', '27"-28"', '29"-30"', '31"-32"', '33"-34"'],
             ['HIP', '35"-36"', '37"-38"', '39"-40"', '41"-42"', '43"-44"'],
           ],
            "DAYWEAR": [
            ['SIZE', 'XS', 'S', 'M', 'L', 'XL', '2XL'],
            ['CUP', '30 A/B', '32 A/B', '34 B/C', '36 B/C', '38 B/C', '40 B/C'],
             ['DRESS', '0-2', '4-6', '8-10', '10-12', '14-16', '18-20'],
             ['WAIST', '25"-26"', '27"-28"', '29"-30"', '31"-32"', '33"-34"', '35"-36"'],
             ['HIP', '35"-36"', '37"-38"', '39"-40"', '41"-42"', '43"-44"', '45"-46"'],
           ],
        },
        sizeChartActive: 'BRALETTES',
        sizeChartActiveSub: ''
      },
      computed:{

      },
      watch: {

      },
      methods: {
        eventListeners: function(){
          //info Tips
          $(".tip-toggle").each(function() {
            $(this).click(function() {
              $(this).children(".SizeCalc-info-plus").toggle()
              $(this).children(".SizeCalc-info-minus").toggle()
              $(this).siblings(".tip-copy").toggle('fast')
            })
          })
          //Fit nav sticky top
          $(window).scroll(function () {
            let $heightScrolled = $(window).scrollTop();
            let $defaultHeight = 75; //when value exceeded, fitnav sticks to top 
            if ($heightScrolled > $defaultHeight) {
              $('#fitNav').addClass('FitNav--scrolled')
            }
            else {
              $('#fitNav').removeClass('FitNav--scrolled')
            }
          });
          //sister chart toggle
          $(".sister-chart-toggle").each(function(){
            $(this).click(function() {
              $("#sister-table").toggle('fast')
              $(".sister-chart-toggle-arrow").each(function(){
                $(this).toggle('fast')
              })
            })
          })
          //display fit video
          $("#video-cta").click(function(){
            $(".SizeCalc-video-preview").hide()
            $("#fit-video").show('fast')
          })
          //Faq togglers
          $(".FitGuide-faq-title-wrap").each(function(){
            $(this).click(function(){
              $(this).siblings('.FitGuide-faq-par').toggle('fast')
              $(this).children('.FitGuide-faq-plus').toggle()
              $(this).children('.FitGuide-faq-minus').toggle()
            })
          })

        },
        calculateSizes: function(e){
          e.preventDefault()
          const bandSize = this.getBandSize(this.bandMeasurement)
          const cupSize = bandSize ? this.getCupSize(bandSize, this.bustSize) : null
          this.braSize = cupSize ? bandSize.toString() + cupSize : null

          //Get data
          // if (gtag){
          //     gtag('event', 'calculate_size', {
          //     'band_measurement_input': this.bandMeasurement,
          //     'bust_size_input': this.bustSize,
          //     'calculated_band_size': bandSize,
          //     'calculated_cup_size': cupSize,
          //     'calculated_bra_size': this.braSize
          //   })
          // }

          if(this.braSize == null){
            this.calcFailure = true
            this.showEmailCapture = false
            this.showEmailCaptureSuccess = false
          } else {
            this.calcFailure = false
            if(this.notCarried.includes(this.braSize)){
              this.showEmailCapture = true
            } else {
              this.showEmailCapture = false
              this.showEmailCaptureSuccess = false
            }
            this.braletteSize = this.getAltSize(this.braSize, "bralettes")
            this.bustySize = this.getAltSize(this.braSize, "busty")
            this.getRecoCollections()
            $('#size-calc-submit').toggleClass('SizeCalc-btn--success')
            $('#size-calc-submit').prop("value", "check out your size below")
          }

        },
        getBandSize: function(band){
          const bandFloor = Math.floor(band)
          if (bandFloor % 2 == 0) {
            if (bandFloor <= 35) return bandFloor + 4
            else if (bandFloor > 35 && bandFloor <= 39) return bandFloor + 2
            else if (bandFloor > 39) return bandFloor
          } else {
            if (bandFloor <= 35) return bandFloor + 3
            else if (bandFloor > 35 && bandFloor <= 39) return bandFloor + 1
            else if (bandFloor > 39) return bandFloor - 1
          }
          return null
        },
        getCupSize: function(bandSize, bustSize){
          const cupIndex = Math.round(bustSize - bandSize)
          const cupSizes = [ 'AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'G', 'H', 'I', 'J', 'K' ]
          
          if (cupIndex < 0 || cupIndex > 11) {
            return null
          }
          
          return cupSizes[cupIndex]
        },
        getAltSize: function(braSize, category){
          const altSizes = {
            "bralettes" : {
              XS : ["30A", "30B"],
              S : ["32A", "32B"],
              M : ["34B", "34C"],
              L : ["36B", "36C"],  
              XL : ["38B", "38C"],       
              XXL : ["40B", "40C"],
            }
          }
          for(const altSize in altSizes[category]){
            if(altSizes[category][altSize].includes(braSize)){
              return altSize
            }
          }
          return null
        },
        getRecoCollections: function() {
          const collections = window.LivelyFitGuide.reco_collections
          let recoCollections = []
          collections.forEach((collection, index) => {
            fetch(window.Shopify.routes.root + `collections/${collection.handle}/products.json`)
              .then(response => response.json())
              .then(data => {
                //search all products of a collection
                console.log(data)
                for(const product of data.products){
                  const braSizeFilter = '?filter.v.option.size=' + this.braSize
                  const alphaSizeFilter = '?filter.v.option.size=' + this.braletteSize && '&filter.v.option.size=' + this.braletteSize
                  console.log(product.variants)
                  
                  // Check if any variant has the matching size and is available
                  const hasMatchingVariant = product.variants.some(variant => {
                    return variant.available && (
                      variant.option1 === this.braSize ||
                      (this.braletteSize && variant.option1 === this.braletteSize) ||
                      (this.bustySize && variant.option1 === this.bustySize)
                    )
                  })
                  
                  if(hasMatchingVariant){
                    // Check which size matched to set the appropriate filter URL
                    const braMatch = product.variants.some(v => v.available && v.option1 === this.braSize)
                    const braletteMatch = !braMatch && this.braletteSize && product.variants.some(v => v.available && v.option1 === this.braletteSize)
                    
                    if(braMatch){
                      collection.filteredUrl = window.Shopify.routes.root + `collections/${collection.handle}/${braSizeFilter}`
                    } else if(braletteMatch){
                      collection.filteredUrl = window.Shopify.routes.root + `collections/${collection.handle}/${alphaSizeFilter}`
                    } else {
                      // Default to bra size filter if busty size matched
                      collection.filteredUrl = window.Shopify.routes.root + `collections/${collection.handle}/${braSizeFilter}`
                    }
                    
                    collection.order = index
                    recoCollections.push(collection)
                    break
                  }
                }
                //bc the above async foreach returns the collections in a different order, resort the collections
                recoCollections = recoCollections.sort((prev, curr) => {
                  return prev.order - curr.order
                })
              })
              .catch(err => console.log(err))
          })
          this.recoCollections = recoCollections
        },
        getSisterSize: function(e){
          e.preventDefault()

          this.sisterInput = document.getElementById('sister-input').value.toUpperCase()
            .replace(' ', '')
            .replace('E', 'DD')
            .replace('F', 'DDD')
            .replace('DDDD', 'G')
        
          const rowIndex = this.sisterChart.findIndex(row => row.includes(this.sisterInput))

          //get input data
          // if (gtag){
          //   gtag('event', 'calculate_sister_size', {
          //     'input': this.sisterInput,
          //     'size_found_in_chart': (rowIndex != -1)
          //   })
          // }
          
          if(rowIndex != -1){
            const row = this.sisterChart[rowIndex]

            this.sisterRowHighlight = rowIndex //for highlighting the correct row in the chart
            this.sisterIndex = row.indexOf(this.sisterInput) //find the index of the input size in the corresponding row
            this.upperSister = row[this.sisterIndex + 1]
            this.upperSisterUrl = this.notCarried.includes(this.upperSister) ? '' : window.Shopify.routes.root + `collections/bras/${'size-' + this.upperSister}`
            this.lowerSister = row[this.sisterIndex - 1]
            this.lowerSisterUrl = window.Shopify.routes.root + `collections/bras/${'size-' + this.lowerSister}`

            //display size chart
            $('#size-chart-wrapper').show()
            //disable button
            $('#sister-submit').toggleClass('SizeCalc-btn--success')
            $('#sister-submit').prop("value", "check out your sister sizes")
            this.sisterFailure = false
          } else {
            this.sisterFailure = true
            $('#size-chart-wrapper').hide()
          }
        },
        resetSister: function(e){
          if(e.key !== 'Enter'){
            $('#sister-submit').removeClass('SizeCalc-btn--success')
            $('#sister-submit').prop("value", "calculate your sister sizes")
          }
        },
        resetCalc: function(e){
          if(e.key !== 'Enter'){
            $('#size-calc-submit').removeClass('SizeCalc-btn--success')
            $('#size-calc-submit').prop("value", "calculate your bra size")
          }
        },
        handleChartMainNavClick: function(e){ 
          this.sizeChartActive = e.target.innerText
          if (!this.sizeCharts[this.sizeChartActive].length){ 
            this.sizeChartActiveSub = Object.keys(this.sizeCharts[this.sizeChartActive])[0]//default to first sub item
          }
        },
        handleChartSubNavClick: function(e){
          this.sizeChartActiveSub = e.target.innerText
        },
        handleNavClick: function(e){
          const id = e.target.id
          let scrollTop = 0
          let offset = window.innerWidth >= 1024 ? 250 : 150
          if ($(window).scrollTop() <= 75){
            offset += 30 //accounts for fitnav switching top
          }
          //set scroll top to location of item on page
          if(id === 'Find Your Size' || id === 'get-started'){
            scrollTop = $('#size-calc').offset().top
          } else if (id === 'Size Charts') {
            scrollTop = $('#size-charts').offset().top
          } else if (id === "FAQs"){
            scrollTop = $('#fit-guide-faq').offset().top
          } else if (id === 'Book a Fitting'){
            window.open("https://wearlively.as.me/?calendarID=3758715", "_blank");
          } else if (id === 'watch-video'){
            $(".SizeCalc-video-preview").hide()
            $("#fit-video").show('fast')
            scrollTop = $('#fit-video').offset().top
          }
          //add & remove active classes
          $('.FitNav-link').each(function() {
            $(this).removeClass('FitNav-item--active')
          })
          e.target.classList.add('FitNav-item--active')
          //do the scroll
          $('html, body').animate({
              scrollTop: scrollTop - offset
          }, 'fast'); 
        },
        bookFitSeshClick: function(){
            // if (gtag){
            //   gtag('event', 'book_fit_sesh_click')
            // }
        },
        handleKlaviyoFormSubmit: async function(e){
          e.preventDefault()
          const input = document.getElementById("customer-email")
          const email = input.value
          const public_key = 'V2aAAQ'
          const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${public_key}`
          const size = this.braSize
          const body = JSON.stringify({
            "data": {
              "type": "subscription",
              "attributes": {
                "profile": {
                  "data": {
                    "type": "profile",
                    "attributes": {
                      "properties": {
                        "requested_size": size,
                        "signup_source": "fitguide"
                      },
                      "email": email
                    }
                  }
                }
              },
              "relationships": {
                "list": {
                  "data": {
                    "type": "list",
                    "id": "Vw5rKT"
                  }
                }
              }
            }
          })
          try {
            const response = await fetch(url, {
              method: "POST",
              headers: { "Content-Type": "application/json", "revision": "2023-07-15" },
              body : body,
              redirect: 'follow',
            })
            if(response.ok){
              this.showEmailCapture = false
              this.showEmailCaptureSuccess = true
            }
          } catch (err){
            console.log(err.message)
          }
        },
      },
      created(){

      }, 
      mounted(){
        this.eventListeners()
        //set default size chart for pdp overlay 
        const sizeType = this.$el.getAttribute('data-size-type')
        if(sizeType){
          if(sizeType == 'panties'){
            this.sizeChartActive = 'PANTIES'
          } else if(sizeType.includes('daywear')){
            this.sizeChartActive = 'DAYWEAR'
          } 
          if (!this.sizeCharts[this.sizeChartActive].length){ 
            this.sizeChartActiveSub = Object.keys(this.sizeCharts[this.sizeChartActive])[0]//default to first sub item if applicable
          }
        }
      }
    })
  }
}







